import React from 'react';
import { Box, Typography, Pagination } from '@mui/material';

/**
 * Control de paginación reutilizable para los listados del sistema.
 * Muestra "Mostrando X–Y de Z resultados" + un paginador numérico (con
 * botones de primera/última página) usando el componente Pagination de MUI
 * — en vez de reinventar la lógica de "..." para listas largas.
 *
 * `page` es 0-indexado, igual que el estado ya usado en cada pantalla, para
 * no tener que tocar el resto de la lógica de cada página al adoptarlo.
 */
export default function PaginacionControl({ page, rowsPerPage, count, onPageChange }) {
  const showAll = rowsPerPage === -1;
  const totalPages = showAll ? 1 : Math.max(1, Math.ceil(count / rowsPerPage));
  const desde = count === 0 ? 0 : (showAll ? 1 : page * rowsPerPage + 1);
  const hasta = count === 0 ? 0 : (showAll ? count : Math.min(count, (page + 1) * rowsPerPage));

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 1,
      mt: 1,
    }}>
      <Typography variant="body2" color="text.secondary">
        {count === 0
          ? 'Sin resultados'
          : `Mostrando ${desde}–${hasta} de ${count} resultado${count === 1 ? '' : 's'}`}
      </Typography>
      {!showAll && totalPages > 1 && (
        <Pagination
          count={totalPages}
          page={page + 1}
          onChange={(_, value) => onPageChange(value - 1)}
          showFirstButton
          showLastButton
          siblingCount={1}
          boundaryCount={1}
          size="small"
          color="primary"
        />
      )}
    </Box>
  );
}
